import { createFileRoute } from '@tanstack/react-router';

import ComingSoonCover from '@/components/ComingSoonCover';

import placeholder from './-assets/placeholder-contract-and-cost.png';

export const Route = createFileRoute(
  '/_staff/networks/_layout/_placeholders/contract-and-cost',
)({
  component: () => <ComingSoonCover placeholderImage={placeholder} />,
});
